import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "hadrian-select" }
const _hoisted_2 = ["aria-labelledby", "id", "disabled"]
const _hoisted_3 = ["aria-labelledby", "aria-expanded", "aria-activedescendant"]
const _hoisted_4 = ["id", "onClick", "aria-selected", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hadrianLabel = _resolveComponent("hadrianLabel")!
  const _component_iconArrow = _resolveComponent("iconArrow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!_ctx.inputLabel)
      ? (_openBlock(), _createBlock(_component_hadrianLabel, {
          key: 0,
          text: _ctx.inputLabel,
          mandatory: _ctx.mandatory,
          htmlFor: _ctx.buttonId,
          id: _ctx.labelId
        }, null, 8, ["text", "mandatory", "htmlFor", "id"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["hadrian-select__input-wrapper", { 'wrapper-height-thin': _ctx.variant === 'thin' }])
    }, [
      _createElementVNode("button", {
        "aria-haspopup": "listbox",
        "aria-labelledby": `${_ctx.labelId} ${_ctx.getId(_ctx.internalValue)}`,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleHidden && _ctx.toggleHidden(...args))),
        onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onButtonKeyPress && _ctx.onButtonKeyPress(...args))),
        onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hasBeenOpened = true)),
        class: _normalizeClass(["hadrian-select__input", {
          'hadrian-select__input--invalid': _ctx.mandatory && !_ctx.internalValue && _ctx.hasBeenOpened,
          'hadrian-select__input--placeholder': !_ctx.internalValue,
          'input-height-thin': _ctx.variant === 'thin',
        }]),
        ref: "inputButton",
        id: _ctx.buttonId,
        disabled: _ctx.disabled,
        type: "button"
      }, [
        _renderSlot(_ctx.$slots, "option", { option: _ctx.internalValue }, () => [
          _createElementVNode("span", null, _toDisplayString(_ctx.internalValue ? _ctx.getLabel(_ctx.internalValue) : _ctx.placeholder), 1)
        ]),
        _createVNode(_component_iconArrow, {
          class: _normalizeClass(["hadrian-select__chevron", { 'hadrian-select__chevron--rotated': !_ctx.hidden }])
        }, null, 8, ["class"])
      ], 42, _hoisted_2),
      _createElementVNode("ul", {
        tabindex: "-1",
        role: "listbox",
        "aria-labelledby": _ctx.labelId,
        "aria-expanded": _ctx.hidden ? 'false' : 'true',
        "aria-activedescendant": _ctx.getId(_ctx.internalValue),
        ref: "expandableItemList",
        onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
        onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onListKeyPress && _ctx.onListKeyPress(...args))),
        class: _normalizeClass(["hadrian-select__list hidden", { 'hadrian-select__list--avoid-scrolling': _ctx.avoidScrolling }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            role: "option",
            key: _ctx.getKey(option),
            id: _ctx.getId(option),
            onClick: ($event: any) => (_ctx.hardSelect(option)),
            class: _normalizeClass(["hadrian-select__option", { 'hadrian-select__option--selected': _ctx.isOptionSelected(option) }]),
            "aria-selected": _ctx.isOptionSelected(option) ? 'true' : 'false',
            "aria-label": _ctx.getLabel(option)
          }, [
            _renderSlot(_ctx.$slots, "option", { option: option }, () => [
              _createTextVNode(_toDisplayString(_ctx.getLabel(option)), 1)
            ])
          ], 10, _hoisted_4))
        }), 128))
      ], 42, _hoisted_3)
    ], 2)
  ]))
}